module.exports = __webpack_public_path__ + "img/icon-differentials_04.1f9e49de.svg";